// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"55313ead","7":"76e99e46","293":"22aebec6","488":"be8b15f8","498":"3b64652d","744":"4de47812","857":"52624864","954":"77d4a869","994":"b1e7dfe0"}[chunkId] + ".chunk.js";
};